import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export default function TidakDitemukan() {
  return (
    <div className="min-h-screen flex flex-col" data-testid="halaman-404">
      <header className="kaca border-b">
        <div className="max-w-[1000px] mx-auto px-4 md:px-8 h-14 flex items-center">
          <Link to="/" data-testid="tautan-beranda" className="flex items-center gap-2">
            <ShieldCheck size={18} className="text-primary" aria-hidden="true" />
            <span className="font-heading font-bold text-lg">PAM-IT</span>
          </Link>
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="max-w-lg text-center">
          <p className="label-kecil">Halaman tidak ada</p>
          <h1 className="mt-4 text-4xl font-bold">Alamatnya tidak kami kenali</h1>
          <p className="mt-4 text-muted-foreground">
            Mungkin tautannya salah tulis atau halamannya sudah pindah. Coba mulai dari beranda.
          </p>
          <div className="mt-8 flex flex-wrap gap-3 justify-center">
            <Link to="/" data-testid="btn-ke-beranda" className="tombol-utama px-5 py-2.5 rounded text-sm">Ke beranda</Link>
            <Link to="/verifikasi" className="tombol-garis px-5 py-2.5 rounded text-sm">Cek surat</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
